import RequestService from '../requestService';

import { client } from '../../client';
import { SakstypeUnique, SakstypeUniqueLight } from '../../../models/sakstypeUnique';
import { ArkivdelLight } from '../../../models/arkivdelLigh';
import { PaginatedResult } from '../../../models/paginatedResult';
import { Sakstype } from '../../../models';
import { ItemPropPatch, patchItemPropIntoCache } from '../../rtk-queries/queryApiCreator';


export default class saksTypeUniqueService extends RequestService<SakstypeUnique, 'sakstypeUnique'> {


    arkivdelList = async (searchString: string) => client.get<PaginatedResult<ArkivdelLight>>(`${this.serviceName}/arkivdel?q=${encodeURIComponent(searchString)}`);

    OpprettDatabaseViewForSakstype =
        async (sakstype: number) =>
            client.post<number>(`${this.serviceName}/opprett_databaseView_for_sakstype`, sakstype);


    OpprettDatabaseViewForSakstypeM =
        async (sakstype: number, sakstypeM: number) =>
            client.post<number>(`${this.serviceName}/${encodeURIComponent(sakstype)}/${encodeURIComponent(sakstypeM)}/opprett_databaseView_for_sakstype_samleMappe`, sakstype);

    SjekkSchema =
        async () =>
            client.get<boolean>(`${this.serviceName}/sjekkDbSchema`);

    hentSakstypeListe =
        async (searchString: string) =>
            client.get<Sakstype[]>
                (`${this.serviceName}/hentSakstypeListe?q=${encodeURIComponent(searchString)}`);

    hentSakstypeUniqueListe =
        async (searchString: string) =>
            client.get<SakstypeUniqueLight[]>
                (`${this.serviceName}/hentSakstypeUniqueLightListe?q=${encodeURIComponent(searchString)}`);

    // hentSakstypeUniqueAlleListe =
    //     async (refId: number) =>
    //         client.get<SakstypeUniqueLight[]>
    //             (`${this.serviceName}/hentSakstypeUniqueLightForTilleggsdataListe?q=${encodeURIComponent(searchString)}`);

}

